import React, { useState, useEffect } from "react";
import { Navigation } from "../components/navigation";
import JsonData from "../data/data.json";
import SmoothScroll from "smooth-scroll";
import "../App.css";
import { SiteData } from "../constants/interfaces";
import { defaultSiteData } from "../constants/globals";
import Values from "../components/values";
import { aboutUsStyle } from "../style/aboutUsStyle";
import Team from "../components/team";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const About = () => {
  const [landingPageData, setLandingPageData] = useState<SiteData>(defaultSiteData);
  useEffect(() => {
    //@ts-ignore
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation/>
      {/* About Section */}
      <div style={aboutUsStyle.container}>
        <div style={aboutUsStyle.overlay}>
          <div style={aboutUsStyle.header}>
            <h1 style={aboutUsStyle.title}>About The Club</h1>
            <p style={aboutUsStyle.subtitle}>
              {/* TODO: move all text into data.json sometime down the road */}
              We’re a club at UBC that develops pro-bono software solutions for nonprofits and promotes tech for social good.
            </p>
            <button style={aboutUsStyle.button}>Read More</button>
          </div>
        </div>
      </div>
      
      {/* Add some spacing here */}
      <div style={aboutUsStyle.spacer}></div>

      {/* Values Section */}
      <div style={aboutUsStyle.valuesContainer}>
        <Values />
      </div>
      <Team data = {landingPageData?.Team}/>
    </div>
  );
};

export default About;

